var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("DataTableWrapper", {
        ref: "tableWrapper",
        attrs: {
          initialSortBy: _vm.initialSortBy,
          "data-source": {
            type: "AxisGQL",
            query: require("@/services/gql/types/BlogPosts/queries/blogPostsGrid.gql"),
          },
          headers: _vm.$options.headersConfig,
          filters: {
            id: { control: "text", modifier: "contains" },
            title: { control: "text", modifier: "contains" },
            slug: { control: "text", modifier: "contains" },
            isFeatured: {
              control: "select",
              options: [
                {
                  value: true,
                  text: "Да",
                },
                {
                  value: false,
                  text: "Нет",
                },
              ],
              dataType: Boolean,
            },
            status: {
              control: "select",
              options: [..._vm.$options.statusList],
              dataType: String,
            },
            isArchived: {
              control: "select",
              options: [
                {
                  value: true,
                  text: "Да",
                },
                {
                  value: false,
                  text: "Нет",
                },
              ],
              dataType: Boolean,
            },
            createdAt: { control: "date-range" },
            updatedAt: { control: "date-range" },
            translations: {
              control: "select",
              options: [
                {
                  value: "ru",
                  text: "ru",
                },
                {
                  value: "en",
                  text: "en",
                },
                {
                  value: "ja",
                  text: "ja",
                },
                {
                  value: "zh",
                  text: "zh",
                },
                {
                  value: "ko",
                  text: "ko",
                },
              ],
            },
          },
          "stored-headers": _vm.getCurrentViewCols,
          "views-list": _vm.getViewList,
          "active-view-key": _vm.getActiveViewKey,
          "views-loading": _vm.$async.updateMe.$pending,
        },
        on: {
          "query-state-updated": _vm.getStateQuery,
          "view-changed": _vm.updateStoredView,
          "active-view-changed": _vm.updateStoredActiveView,
          "remove-view": _vm.removeStoredView,
          "data-loaded": _vm.onTableDataChange,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({
              tableProps,
              tableListeners,
              filtersProps,
              filtersListeners,
            }) {
              return [
                _c(
                  "v-data-table",
                  _vm._g(
                    _vm._b(
                      {
                        attrs: {
                          "fixed-header": "",
                          height: "80vh",
                          "items-per-page": _vm.$options.perPage.itemsPerPage,
                          "footer-props": {
                            itemsPerPageOptions:
                              _vm.$options.perPage.itemsPerPageOptions,
                          },
                        },
                        on: {
                          "update:sort-by": _vm.updateSortBy,
                          "update:sort-desc": function ($event) {
                            _vm.sortDesc = $event
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            _vm._l(_vm.$options.headersConfig, function (h, i) {
                              return {
                                key: `header.${h.value}`,
                                fn: function () {
                                  return [
                                    _c(
                                      "v-tooltip",
                                      {
                                        key: i,
                                        attrs: {
                                          "open-delay": "350",
                                          bottom: "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _c("span", _vm._g({}, on), [
                                                    _vm._v(
                                                      " " + _vm._s(h.text) + " "
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(h.description)),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              }
                            }),
                            {
                              key: `body.prepend`,
                              fn: function ({}) {
                                return [
                                  _c(
                                    "DataTableFilters",
                                    _vm._g(
                                      _vm._b(
                                        { attrs: { "is-grid-selectable": "" } },
                                        "DataTableFilters",
                                        filtersProps,
                                        false
                                      ),
                                      filtersListeners
                                    )
                                  ),
                                ]
                              },
                            },
                            _vm._l(_vm.$options.headersConfig, function (h, i) {
                              return {
                                key: `item.${h.value}`,
                                fn: function ({ item }) {
                                  return [
                                    _c("div", { key: i }, [
                                      h.type === "number" &&
                                      item[h.value] !== null
                                        ? _c("div", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatAmount(
                                                    item[h.value]
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ])
                                        : h.text === "Заголовок"
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    title: "Редактировать",
                                                    to: {
                                                      name: "page-blog-post",
                                                      params: { id: item.id },
                                                    },
                                                  },
                                                },
                                                [_vm._v(_vm._s(item[h.value]))]
                                              ),
                                            ],
                                            1
                                          )
                                        : h.type === "date"
                                        ? _c(
                                            "div",
                                            [
                                              _c("DateTimeCell", {
                                                attrs: { value: item[h.value] },
                                              }),
                                            ],
                                            1
                                          )
                                        : h.value === "slug"
                                        ? _c("div", [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.mixCutSlug(item[h.value])
                                                )
                                              ),
                                            ]),
                                          ])
                                        : h.value === "copySlug"
                                        ? _c("div", [
                                            _c(
                                              "a",
                                              {
                                                attrs: { title: "Копировать" },
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: { icon: "" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.mixCopySlugHandler(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v(
                                                        "mdi-content-copy"
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ])
                                        : h.type === "boolean"
                                        ? _c(
                                            "div",
                                            [
                                              _c("v-icon", {
                                                attrs: {
                                                  color: item[h.value]
                                                    ? "success"
                                                    : "grey",
                                                },
                                                domProps: {
                                                  textContent: _vm._s(
                                                    "mdi-checkbox-marked-circle"
                                                  ),
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : h.type === "actions"
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: {
                                                      name: "page-blog-post",
                                                      params: { id: item.id },
                                                    },
                                                    title: "Редактировать",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    { attrs: { icon: "" } },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("mdi-pencil"),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "a",
                                                { attrs: { title: "Удалить" } },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: { icon: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.deleteBlogPost(
                                                            item.id
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            color: "red",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-trash-can-outline"
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : h.value === "translations"
                                        ? _c("div", [
                                            _vm._v(
                                              _vm._s(_vm.getLanguage(item))
                                            ),
                                          ])
                                        : h.value === "status"
                                        ? _c("div", [
                                            _vm._v(
                                              _vm._s(_vm.mixGetStatus(item))
                                            ),
                                          ])
                                        : _c("div", [
                                            _vm._v(
                                              " " + _vm._s(item[h.value]) + " "
                                            ),
                                          ]),
                                    ]),
                                  ]
                                },
                              }
                            }),
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.mixSelectedItems,
                          callback: function ($$v) {
                            _vm.mixSelectedItems = $$v
                          },
                          expression: "mixSelectedItems",
                        },
                      },
                      "v-data-table",
                      tableProps,
                      false
                    ),
                    tableListeners
                  )
                ),
              ]
            },
          },
        ]),
      }),
      _c("ConfirmationDialog", {
        ref: "confirmBlogPostRemoving",
        attrs: { confirmText: "Удалить" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }